import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "my-position-info"
}
const _hoisted_2 = {
  key: 0,
  class: "my-position-info--error"
}

import { onUnmounted, computed } from 'vue';
import { useGeolocation, watchThrottled } from '@vueuse/core'
import { useUser } from '@/store/user'
import { useUserPosition } from '@/store/user-position'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserPositionBar',
  setup(__props) {

const { user } = useUser()
const { setPosition, savePosition } = useUserPosition()

const { coords, error, pause } = useGeolocation()

const errorMessage = computed(() => {
  if (error.value) {
    //return 'Could not retrieve your current location'
  }

  return null
})

const onPositionChange = () => {
  const { latitude, longitude } = coords.value
  setPosition(latitude, longitude)
  savePosition(latitude, longitude)
}


watchThrottled(
  coords,
  onPositionChange,
  { throttle: 3000 },
)

onUnmounted(pause)

return (_ctx: any,_cache: any) => {
  return (_unref(user))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_unref(errorMessage))
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(errorMessage)), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})